import { Anchor, Avatar, Badge, Group, Paper, Text } from "@mantine/core";
import React from "react";

const ViewSpecificUserModalView = ({ user }) => {
  console.log(user, "user");
  return (
    <Paper>
      <Text align="center" size={25} weight={500} mb="md">
        {user?.firstName} {user?.lastName}
      </Text>
      <Avatar src={user?.logo} size={300} radius="lg" mx="auto" />
      <Group position="center" mt="md">
        <Text size="lg" weight="bold">
          Status:{" "}
        </Text>
        <Badge size="lg" color={user?.status === "active" ? "green" : "red"}>
          {user?.status === "active" ? "Active" : "Inactive"}
        </Badge>
      </Group>
      <Group position="center">
        <Text size="lg" weight="bold">
          User Type:
        </Text>
        <Text size={20} weight={500} align="center" color="dimmed">
          {user?.userRole}
        </Text>
      </Group>

      <Group position="center" align="center">
        <Text size={20}>
          <Anchor
            variant="text"
            href={"mailto:" + user?.email}
            target="_blank"
            rel="noreferrer"
          >
            {user?.email}
          </Anchor>
        </Text>
        <Badge size="lg" color={user?.emailVerified ? "green" : "red"}>
          {user?.emailVerified ? "" : "Not "}Verified
        </Badge>
      </Group>
    </Paper>
  );
};

export default ViewSpecificUserModalView;
